<template>
  <div class="content-top widthAuto">
    <div class="align-center">
      <img src="@/assets/images/website/home/iconHome.svg" @click="toHome" />
      <span class="home" @click="toHome">首页</span>
      <span class="home"> ></span><span class="home" @click="$router.push(path)">资讯列表</span> >
      <span class="dow text-overflow-ellipsis" :title="lable">{{ lable }}</span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    lable: {
      typeof: String,
    },
    path: {
      typeof: String,
    }
  },
  data() {
    return {};
  },
  // watch:{
  //   $route(now, old) {
  //     // console.log(11,now, old)
  //   },
  // },
  computed: {
    routerlable() {
      return this.$route.name;
    },
  },
  methods: {
    toHome() {
      if (window.DOMAIN_CONFIG.newuser) {
        window.location.href = `${window.DOMAIN_CONFIG.newuser}`
      } else {
        this.$router.push('/home')
      }
    }
  }
};
</script>
<style lang="less" scoped>
.content-top {
  padding: 27px 0 25px;
  font-size: 14px;
  font-family: MicrosoftYaHei;
  line-height: 19px;

  img {
    height: 15px;
    margin-right: 5px;
    cursor: pointer;
  }

  .home {
    padding-right: 5px;
    color: #333333;
    cursor: pointer;
  }

  .dow {
    display: inline-block;
    max-width: 1000px;
    padding-left: 5px;
    color: #999999;
  }
}
</style>
